const homeInitState = {
  count: 0,
  status: 'idle'
};

export default homeInitState;
